var EMAIL_REGEX = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;
export var maskEmailIds = function maskEmailIds(text) {
  return text.replace(EMAIL_REGEX, '***@***');
};